import React, { useState, useEffect } from 'react';
import Dashboard from './components/Dashboard';
import Conciergerie from './components/Conciergerie';
import Invoice from './components/Invoice';
import './App.css';

export function apiFetch(path, password, options = {}) {
  return fetch(`/api${path}`, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      'x-app-password': password,
      ...(options.headers ?? {})
    }
  });
}

function App() {
  const [authenticated, setAuthenticated] = useState(false);
  const [password, setPassword] = useState('');
  const [authError, setAuthError] = useState('');
  const [activeTab, setActiveTab] = useState('dashboard');

  useEffect(() => {
    const stored = localStorage.getItem('goobnclean_pwd');
    if (stored) { setPassword(stored); setAuthenticated(true); }
  }, []);

  const login = async (e) => {
    e.preventDefault();
    setAuthError('');
    try {
      const now = new Date();
      const month = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}`;
      const res = await fetch(`/api/hostex/reservations?month=${month}`, {
        headers: { 'x-app-password': password }
      });
      if (res.status === 401) return setAuthError('Mot de passe incorrect');
      localStorage.setItem('goobnclean_pwd', password);
      setAuthenticated(true);
    } catch {
      setAuthError('Impossible de joindre le serveur');
    }
  };

  const logout = () => {
    localStorage.removeItem('goobnclean_pwd');
    setAuthenticated(false);
    setPassword('');
  };

  if (!authenticated) {
    return (
      <div className="login-container">
        <div className="login-card">
          <h1 className="app-title">GooBnClean</h1>
          <p className="app-subtitle">Gestion financière co-hôte</p>
          <form onSubmit={login}>
            <input
              type="password"
              placeholder="Mot de passe"
              value={password}
              onChange={e => setPassword(e.target.value)}
              className="input"
              autoFocus
            />
            {authError && <p className="error">{authError}</p>}
            <button type="submit" className="btn btn-primary">Connexion</button>
          </form>
        </div>
      </div>
    );
  }

  const tabs = [
    { id: 'dashboard',     label: 'Dashboard' },
    { id: 'conciergerie',  label: 'Conciergerie' },
    { id: 'facturation',   label: 'Facturation' },
  ];

  return (
    <div className="app">
      <header className="header">
        <h1 className="app-title">GooBnClean</h1>
        <nav className="nav">
          {tabs.map(t => (
            <button
              key={t.id}
              className={`tab${activeTab === t.id ? ' active' : ''}`}
              onClick={() => setActiveTab(t.id)}
            >{t.label}</button>
          ))}
          <button className="btn-logout" onClick={logout}>Déconnexion</button>
        </nav>
      </header>
      <main className="main">
        <div style={{ display: activeTab === 'dashboard'    ? '' : 'none' }}><Dashboard    password={password} /></div>
        <div style={{ display: activeTab === 'conciergerie' ? '' : 'none' }}><Conciergerie password={password} /></div>
        <div style={{ display: activeTab === 'facturation'  ? '' : 'none' }}><Invoice      password={password} /></div>
      </main>
    </div>
  );
}

export default App;
